(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template-hulkapps-backup"]) return;
  try {
    
emitter.on("window::qty__adjust", function(qty) {
  $( "input[name='update']" ).trigger( "click" );
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-template"]) return;
  try {
    
$(document).on('submit', 'form[action="/cart"]', function(e) {
  var blocked = false;
  $('.cart-item').each(function() {
    var max = parseInt($(this).attr('data-max'), 10);
    var $input = $(this).find('.js-qty__num');
    var current = parseInt($input.val(), 10);
    if (!isNaN(max) && max > 0 && current > max) {
      $input.val(max);
      blocked = true;
    }
  });
  if (blocked) {
    e.preventDefault();
    e.stopImmediatePropagation();
    $('form[action="/cart"]').submit();
    return false;
  }
});
emitter.on("window::qty__adjust", function(qty) {
  var blocked = false;
  $('.cart-item').each(function() {
    var max = parseInt($(this).attr('data-max'), 10);
    var $input = $(this).find('.js-qty__num');
    var current = parseInt($input.val(), 10);
    if (!isNaN(max) && max > 0 && current > max) {
      $input.val(max);
      showStockAlert($(this));
      blocked = true;
    }
  });
  if (!blocked) {
    $( "input[name='update']" ).trigger( "click" );
  }
});

function showStockAlert($cartItem) {
  if ($cartItem.find('.stock-alert').length === 0) {
    $cartItem.append('<p class="stock-alert" style="color:red; font-size:0.85em; margin-top:4px;">在庫上限に達しました。これ以上追加できません。</p>');
  }
}

function hideStockAlert($cartItem) {
  $cartItem.find('.stock-alert').remove();
}

// ajax-cart.jsの処理後に在庫チェック
$(document).on('click', '.js-qty__adjust--plus', function() {
  var $btn = $(this);
  var $cartItem = $btn.closest('.cart-item');
  var max = parseInt($cartItem.attr('data-max'), 10);
  setTimeout(function() {
    var $input = $btn.closest('.e-quantity').find('.js-qty__num');
    var current = parseInt($input.val(), 10);
    if (!isNaN(max) && max > 0 && current > max) {
      $input.val(max).trigger('change');
      showStockAlert($cartItem);
    } else if (!isNaN(max) && max > 0 && current === max) {
      showStockAlert($cartItem);
    } else {
      hideStockAlert($cartItem);
    }
  }, 100);
});

// マイナスボタン
$(document).on('click', '.js-qty__adjust--minus', function() {
  var $cartItem = $(this).closest('.cart-item');
  hideStockAlert($cartItem);
});

// 直接入力
$(document).on('change blur', '.js-qty__num', function() {
  var $input = $(this);
  var $cartItem = $input.closest('.cart-item');
  var max = parseInt($cartItem.attr('data-max'), 10) || parseInt($input.attr('max'), 10);
  var current = parseInt($input.val(), 10);
  if (!isNaN(max) && max > 0 && current > max) {
    $input.val(max);
    showStockAlert($cartItem);
  } else {
    hideStockAlert($cartItem);
  }
});

// dokopoiの text-align を center に統一
function fixDokopoiAlign() {
  var el = document.getElementById('dokopoiCartBody');
  if (el) {
    el.style.setProperty('text-align', 'center', 'important');
    var observer = new MutationObserver(function() {
      el.style.setProperty('text-align', 'center', 'important');
    });
    observer.observe(el, { attributes: true, attributeFilter: ['style'] });
  }
  // 現在のポイント表示の下に余白を追加
  var midashiInterval = setInterval(function() {
    var midashi = document.getElementById('dokopoiMainLabel');
    if (midashi) {
      midashi.style.setProperty('margin-bottom', '20px', 'important');
      midashi.style.setProperty('display', 'block', 'important');
      clearInterval(midashiInterval);
    }
  }, 200);
}
// DOM読み込み後・dokopoi描画後どちらにも対応
$(document).ready(function() { setTimeout(fixDokopoiAlign, 500); });
$(window).on('load', function() { setTimeout(fixDokopoiAlign, 1000); });
// ギフトラッピング：ローディング表示を出してからカート操作
function giftWrapLoading(show) {
  if (show) {
    if ($('#giftWrapOverlay').length === 0) {
      $('body').append(
        '<div id="giftWrapOverlay">' +
          '<div class="gwrap-spinner"></div>' +
          '<p class="gwrap-text">Now Loading...</p>' +
        '</div>'
      );
    }
    $('#giftWrapCheck').prop('disabled', true);
  } else {
    $('#giftWrapOverlay').remove();
    $('#giftWrapCheck').prop('disabled', false);
  }
}

$(document).on('change', '#giftWrapCheck', function() {
  var variantId = 32438757392446;
  var isChecked = $(this).is(':checked');
  giftWrapLoading(true);

  // 現在のカート状態を取得してから操作
  $.getJSON('/cart.js', function(cart) {
    var existingLine = 0;
    $.each(cart.items, function(i, item) {
      if (item.variant_id === variantId) {
        existingLine = i + 1;
      }
    });

    if (isChecked) {
      if (existingLine > 0) {
        // すでに入っている場合はそのままリロード
        location.reload();
        return;
      }
      // カートに追加
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { id: variantId, quantity: 1 },
        dataType: 'json',
        success: function() {
          location.reload();
        },
        error: function(xhr) {
          giftWrapLoading(false);
          console.log('add error:', xhr.responseText);
          alert('ギフトラッピングの追加に失敗しました。');
        }
      });
    } else {
      if (existingLine === 0) {
        // すでに入っていない場合はそのままリロード
        location.reload();
        return;
      }
      // カートから削除
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: { line: existingLine, quantity: 0 },
        dataType: 'json',
        success: function() {
          location.reload();
        },
        error: function(xhr) {
          giftWrapLoading(false);
          console.log('change error:', xhr.responseText);
          alert('ギフトラッピングの削除に失敗しました。');
        }
      });
    }
  });
});

// ページ読み込み時：カートにギフトラッピングがあればチェックを入れる
$(document).ready(function() {
  var variantId = 32438757392446;
  $.getJSON('/cart.js', function(cart) {
    $.each(cart.items, function(i, item) {
      if (item.variant_id === variantId) {
        $('#giftWrapCheck').prop('checked', true);
      }
    });
  });
});

// ドコポイ「こちら」ログインリンク：hrefで検索・タップ時にローディング表示
function attachLoginLoadingHandler() {
  var link = document.querySelector('a[href*="/account/login"]');
  if (!link) return false;
  if (link.dataset.loginHandlerAttached) return true;

  link.dataset.loginHandlerAttached = 'true';
  link.addEventListener('click', function(e) {
    var href = this.getAttribute('href');
    if (!href) return;
    e.preventDefault();

    // ローディングオーバーレイ表示
    if (!document.getElementById('loginLoadingOverlay')) {
      var overlay = document.createElement('div');
      overlay.id = 'loginLoadingOverlay';
      overlay.style.cssText =
        'position:fixed;top:0;left:0;width:100%;height:100%;' +
        'background:rgba(255,255,255,0.85);' +
        'display:flex;flex-direction:column;' +
        'justify-content:center;align-items:center;z-index:9999;';
      overlay.innerHTML =
        '<div style="width:48px;height:48px;border:3px solid #ddd;' +
        'border-top-color:#0a0a0a;border-radius:50%;' +
        'animation:loginSpin 0.8s linear infinite;margin-bottom:16px;"></div>' +
        '<p style="font-size:13px;letter-spacing:0.1em;color:#0a0a0a;">Now Loading...</p>';
      document.body.appendChild(overlay);
    }

    // アニメーション用スタイル注入
    if (!document.getElementById('loginSpinStyle')) {
      var style = document.createElement('style');
      style.id = 'loginSpinStyle';
      style.textContent = '@keyframes loginSpin { to { transform: rotate(360deg); } }';
      document.head.appendChild(style);
    }

    window.location.href = href;
  });
  return true;
}

// MutationObserverでリンクの出現を監視
var loginObserver = new MutationObserver(function() {
  if (attachLoginLoadingHandler()) {
    loginObserver.disconnect();
  }
});
loginObserver.observe(document.body, { childList: true, subtree: true });

// 念のため定期チェックも併用（最大10秒）
var loginCheckCount = 0;
var loginCheckInterval = setInterval(function() {
  loginCheckCount++;
  if (attachLoginLoadingHandler() || loginCheckCount >= 50) {
    clearInterval(loginCheckInterval);
  }
}, 200);

// 戻るボタン対策：ローディングを消す
window.addEventListener('pageshow', function(e) {
  if (e.persisted) {
    var overlay = document.getElementById('loginLoadingOverlay');
    if (overlay) overlay.remove();
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart_template_hulkapps_backup-hulkapps-backup"]) return;
  try {
    
emitter.on("window::qty__adjust", function(qty) {
  $( "input[name='update']" ).trigger( "click" );
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart_template_hulkapps_backup"]) return;
  try {
    
emitter.on("window::qty__adjust", function(qty) {
  $( "input[name='update']" ).trigger( "click" );
});

  } catch(e) { console.error(e); }
})();
})();
